import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import 'store/search';
import Search from 'components/bolt/icons/search';
import Store from 'store/store';
import s from 'components/bolt/header/searchField.sss';

export default class SearchField extends Component {
	constructor(props) {
		super(props);
		this.onSearchInput = this.onSearchInput.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.searchData?.showSearchField && !prevProps.searchData?.showSearchField) {
			this.input?.focus();
		}
	}

	onSearchInput(e) {
		const { searchData } = this.props;
		const lastPageBeforeSearch = searchData?.lastPageBeforeSearch;
		const activePage = Store.get().activePage;
		const searchInput = e?.target?.value || '';
		Store.emit('UPDATE_SEARCH_INPUT', searchInput);

		if (searchInput && activePage !== 'search') {
			Store.emit('LAST_PAGE_BEFORE_SEARCH', activePage);
			Store.emit('SET_ACTIVE_PAGE', 'search');
		} else if (!searchInput && lastPageBeforeSearch) {
			Store.emit('SET_ACTIVE_PAGE', lastPageBeforeSearch, true);
		}
	}

	render({ searchData, isDesktopSearch }) {
		const show = searchData?.showSearchField;
		return (
			<div class={joinClasses(s.container, show && s.show, isDesktopSearch && s.inHeaderBar)}>
				<div class={s.inputContainer}>
					<input
						ref={ref => this.input = ref}
						type="text"
						placeholder="Search"
						class={s.field}
						onInput={this.onSearchInput}
						value={searchData.searchInput}
						tabIndex={show ? 0 : -1}
					/>
					{/* <Search class={s.icon} /> */}
				</div>
			</div>
		);
	}
}